document.addEventListener('DOMContentLoaded', function() {
    const container = document.getElementById('gasRequestModalContainer');
    const hid = document.getElementById('gas_request_id');
    const disp = document.getElementById('gas_request_display');
    const openBtn = document.getElementById('openGasRequestModal');
    const ticketDateInput = document.getElementById('ticket_date');
    const dateFromDisplay = document.getElementById('date_from_display');
    const dateToDisplay = document.getElementById('date_to_display');
    const dateFromHidden = document.getElementById('date_from');
    const dateToHidden = document.getElementById('date_to');
    const form = document.getElementById('driverTripTicketForm');
    // Get routes from data attributes on the form
    const modalUrl = form ? (form.dataset.modalUrl || '/office/driver-trip-tickets/gas-requests-modal') : '/office/driver-trip-tickets/gas-requests-modal';
    const indexRoute = form ? (form.dataset.indexRoute || '/office/driver-trip-tickets') : '/office/driver-trip-tickets';

    // Helper function to get URL query parameter
    function getQueryParam(param) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(param);
    }

    // Helper function to populate form with gas request data
    function populateFormWithGasRequest(sel) {
        if (hid) hid.value = sel.id;
        if (disp) disp.value = sel.display;
        // Update the date from display with gas request date
        if (dateFromDisplay && sel.date) {
            dateFromDisplay.value = sel.date;
        }
        // Set hidden date_from field
        if (dateFromHidden && sel.date) {
            dateFromHidden.value = sel.date;
        }
        // Get yesterday's date for date_to
        var yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        var yesterdayStr = yesterday.toISOString().split('T')[0];
        // Set date_to display and hidden
        if (dateToDisplay) {
            dateToDisplay.value = yesterdayStr;
        }
        if (dateToHidden) {
            dateToHidden.value = yesterdayStr;
        }
        // Set ticket date to gas request date if available, otherwise default to yesterday
        if (ticketDateInput) {
            ticketDateInput.value = (sel && sel.date) ? sel.date : yesterdayStr;
        }
        // Auto-fill the display fields from gas request data
        var driverDisplay = document.getElementById('driver_display');
        var vehicleDisplay = document.getElementById('vehicle_display');
        var plateDisplay = document.getElementById('plate_display');
        var passengerDisplay = document.getElementById('passenger_display');
        var destinationDisplay = document.getElementById('destination_display');
        var purposeDisplay = document.getElementById('purpose_display');
        
        if (driverDisplay) driverDisplay.value = sel.driver || '---';
        if (vehicleDisplay) vehicleDisplay.value = sel.vehicle || '---';
        if (plateDisplay) plateDisplay.value = sel.plate || '---';
        if (passengerDisplay) passengerDisplay.value = sel.passengers || '---';
        if (destinationDisplay) destinationDisplay.value = sel.destination || '---';
        if (purposeDisplay) purposeDisplay.value = sel.purpose || '---';
        
        // Auto-fill issued from stock (no_of_liters from gas request)
        var issuedFromStockDisplay = document.getElementById('issued_from_stock_display');
        if (issuedFromStockDisplay) issuedFromStockDisplay.value = sel.no_of_liters || '---';
        
        // Recompute gas total after selecting gas request
        computeGasTotal();
        
        // Fetch and auto-fill last driver trip ticket data if vehicle exists
        if (sel.vehicle_id) {
            fetchLastDriverTripTicket(sel.vehicle_id);
        }
    }

    // Helper function to fetch and auto-fill last driver trip ticket data
    function fetchLastDriverTripTicket(vehicleId) {
        fetch('/office/driver-trip-tickets/last-ticket/' + vehicleId, {
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
        .then(r => {
            if (!r.ok) throw new Error('Failed to fetch last ticket');
            return r.json();
        })
        .then(data => {
            if (data && data.gas_balance_end !== null && data.gas_balance_end !== undefined) {
                var balanceEl = document.getElementById('gas_balance_in_tank');
                if (balanceEl) {
                    balanceEl.value = data.gas_balance_end;
                }
            }
            if (data && data.speedometer_end !== null && data.speedometer_end !== undefined) {
                var speedometerStartEl = document.getElementById('speedometer_start');
                if (speedometerStartEl) {
                    speedometerStartEl.value = data.speedometer_end;
                }
            }
            // Recompute calculations with new values
            computeSpeedometerDistance();
            computeGasTotal();
        })
        .catch(err => {
            console.warn('Could not fetch last driver trip ticket:', err);
        });
    }

    // Auto-select gas request if gas_request_id is in URL query params
    const gasRequestIdFromUrl = getQueryParam('gas_request_id');
    if (gasRequestIdFromUrl) {
        fetch('/office/driver-trip-tickets/gas-request/' + gasRequestIdFromUrl, {
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
        .then(r => {
            if (!r.ok) throw new Error('Failed to fetch gas request');
            return r.json();
        })
        .then(data => {
            populateFormWithGasRequest(data);
            console.log('Auto-selected gas request:', data);
        })
        .catch(err => {
            console.warn('Could not auto-select gas request:', err);
        });
    }

    function cleanupModalState() {
        // Ensure body scrolling is restored
        document.body.style.overflow = '';
        document.body.classList.remove('modal-open');
        document.body.style.paddingRight = '';
        
        // Remove all modal backdrops
        var backs = document.querySelectorAll('.modal-backdrop');
        backs.forEach(function(b) {
            if (b.parentNode) {
                b.parentNode.removeChild(b);
            }
        });
    }

    function loadModal(url) {
        fetch(url || modalUrl, {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            })
            .then(r => {
                if (!r.ok) throw new Error('Failed to fetch modal');
                return r.text();
            })
            .then(html => {
                if (container) {
                    container.innerHTML = html;
                    // remove any stray backdrops before showing
                    cleanupModalState();
                    
                    if (window.jQuery) {
                        $('#gasRequestModal').modal('show');
                    } else {
                        // vanilla show modal
                        var modalEl = document.getElementById('gasRequestModal');
                        if (modalEl) {
                            modalEl.style.display = 'block';
                            modalEl.classList.add('show');
                        }
                    }
                }
            })
            .catch(err => {
                console.error('Error loading modal:', err);
            });
    }

    if (openBtn) {
        openBtn.addEventListener('click', function() {
            loadModal();
        });
    }
    if (disp) {
        disp.addEventListener('click', function() {
            loadModal();
        });
    }

    // keep form submit guarded and ask for confirmation before saving
    if (form) {
        form.addEventListener('submit', function(e) {
            e.preventDefault();
            if (!hid || !hid.value) {
                alert('Please select a Gas Request before saving.');
                loadModal();
                return;
            }
            if (!window.confirm('Are you sure you want to save this Driver Trip Ticket?')) {
                return;
            }

            // submit via AJAX so we can open the print view in a new tab
            var fd = new FormData(form);
            fetch(form.action, {
                    method: 'POST',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: fd
                })
                .then(function(res) {
                    if (!res.ok) return res.text().then(function(t) {
                        throw new Error(t || 'Request failed');
                    });
                    return res.json().catch(function() {
                        return null;
                    });
                })
                .then(function(data) {
                    if (data && data.viewer_url) {
                        // redirect to the PDF viewer for the created ticket
                        window.location = data.viewer_url;
                        return;
                    }
                    // fallback: navigate to index
                    window.location = indexRoute;
                })
                .catch(function(err) {
                    alert('Failed to save: ' + (err.message || 'Unknown error'));
                });
        });
    }

    // compute speedometer distance automatically
    function computeSpeedometerDistance() {
        var startEl = document.getElementById('speedometer_start');
        var endEl = document.getElementById('speedometer_end');
        var disp = document.getElementById('speedometer_distance_display');
        var hidden = document.getElementById('speedometer_distance');
        if (!startEl || !endEl || !disp || !hidden) return;
        var s = parseFloat(startEl.value);
        var e = parseFloat(endEl.value);
        if (isNaN(s) || isNaN(e)) {
            disp.value = '';
            hidden.value = '';
            return;
        }
        // distance = absolute difference between end and start
        var d = Math.abs(e - s);
        // keep two decimals if needed
        d = Math.round(d * 100) / 100;
        disp.value = d;
        hidden.value = d;
    }

    // compute approx distance (time range) from departure and arrival back
    function formatTime12Hour(time24) {
        if (!time24) return '';
        var parts = time24.split(':');
        var hours = parseInt(parts[0]);
        var minutes = parts[1];
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        if (hours === 0) hours = 12;
        return hours + ':' + minutes + ' ' + ampm;
    }
    
    function computeApproxDistance() {
        var departureEl = document.getElementById('departure_from_office_time');
        var arrivalEl = document.getElementById('arrival_back_time');
        var disp = document.getElementById('approx_distance_display');
        var hidden = document.getElementById('approx_distance');
        if (!departureEl || !arrivalEl || !disp || !hidden) return;
        
        var departure = departureEl.value;
        var arrival = arrivalEl.value;
        
        if (!departure || !arrival) {
            disp.value = '---';
            hidden.value = '';
            return;
        }
        
        // Format as "8:04 am - 5:40 pm"
        var depFormatted = formatTime12Hour(departure);
        var arrFormatted = formatTime12Hour(arrival);
        var timeRange = depFormatted + ' - ' + arrFormatted;
        
        disp.value = timeRange;
        hidden.value = timeRange;
    }

    // compute gas total (Gas Balance In Tank + Issued from stock + Gas Purchased During Trip)
    function computeGasTotal() {
        var balanceEl = document.getElementById('gas_balance_in_tank');
        var issuedEl = document.getElementById('issued_from_stock_display');
        var purchasedEl = document.getElementById('gas_purchased_during_trip');
        var disp = document.getElementById('gas_total_display');
        var hidden = document.getElementById('gas_total');
        if (!disp || !hidden) return;
        
        var balance = parseFloat(balanceEl ? balanceEl.value : 0) || 0;
        var issued = parseFloat(issuedEl ? issuedEl.value : 0) || 0;
        var purchased = parseFloat(purchasedEl ? purchasedEl.value : 0) || 0;
        
        var total = balance + issued + purchased;
        total = Math.round(total * 100) / 100;
        
        disp.value = total;
        hidden.value = total;
        
        // Also recompute gas balance end when total changes
        computeGasBalanceEnd();
    }

    // compute gas balance end (TOTAL - Gas Deduct Used)
    function computeGasBalanceEnd() {
        var totalEl = document.getElementById('gas_total');
        var deductEl = document.getElementById('gas_deduct_used');
        var disp = document.getElementById('gas_balance_end_display');
        var hidden = document.getElementById('gas_balance_end');
        if (!disp || !hidden) return;
        
        var total = parseFloat(totalEl ? totalEl.value : 0) || 0;
        var deduct = parseFloat(deductEl ? deductEl.value : 0) || 0;
        
        var balanceEnd = total - deduct;
        balanceEnd = Math.round(balanceEnd * 100) / 100;
        
        disp.value = balanceEnd;
        hidden.value = balanceEnd;
    }

    document.addEventListener('input', function(e) {
        if (e.target && (e.target.id === 'speedometer_start' || e.target.id === 'speedometer_end')) {
            computeSpeedometerDistance();
        }
        if (e.target && (e.target.id === 'departure_from_office_time' || e.target.id === 'arrival_back_time')) {
            computeApproxDistance();
        }
        if (e.target && (e.target.id === 'gas_balance_in_tank' || e.target.id === 'gas_purchased_during_trip')) {
            computeGasTotal();
        }
        if (e.target && e.target.id === 'gas_deduct_used') {
            computeGasBalanceEnd();
        }
    });

    // compute on load in case old values exist
    computeSpeedometerDistance();
    computeApproxDistance();
    computeGasTotal();
    computeGasBalanceEnd();

    // delegated handler: intercept pagination and selection inside modal container
    document.addEventListener('click', function(e) {
        if (!container || !container.contains(e.target)) return;

        // modal close (data-dismiss)
        var closer = null;
        try {
            closer = e.target.closest('[data-dismiss="modal"]');
        } catch (err) {
            closer = null;
        }
        if (closer) {
            e.preventDefault();
            if (window.jQuery) {
                $('#gasRequestModal').modal('hide');
                setTimeout(function() {
                    cleanupModalState();
                }, 100);
            } else {
                cleanupModalState();
            }
            return;
        }

        // selection button
        var sel = null;
        try {
            sel = e.target.closest('.select-gas-request');
        } catch (err) {
            sel = null;
        }
        if (sel) {
            e.preventDefault();
            const id = sel.getAttribute('data-id');
            const vehicleId = sel.getAttribute('data-vehicle-id');
            const display = sel.getAttribute('data-display');
            const gasRequestDate = sel.getAttribute('data-date');
            if (hid) hid.value = id;
            if (disp) disp.value = display;
            // Update the date from display with gas request date
            if (dateFromDisplay && gasRequestDate) {
                dateFromDisplay.value = gasRequestDate;
            }
            // Set hidden date_from field
            if (dateFromHidden && gasRequestDate) {
                dateFromHidden.value = gasRequestDate;
            }
            // Get yesterday's date for date_to
            var yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            var yesterdayStr = yesterday.toISOString().split('T')[0];
            // Set date_to display and hidden
            if (dateToDisplay) {
                dateToDisplay.value = yesterdayStr;
            }
            if (dateToHidden) {
                dateToHidden.value = yesterdayStr;
            }
            // Set ticket date to the selected gas request date if provided, otherwise default to yesterday
            if (ticketDateInput) {
                ticketDateInput.value = gasRequestDate || yesterdayStr;
            }
            // Auto-fill the display fields from gas request data
            var driverDisplay = document.getElementById('driver_display');
            var vehicleDisplay = document.getElementById('vehicle_display');
            var plateDisplay = document.getElementById('plate_display');
            var passengerDisplay = document.getElementById('passenger_display');
            var destinationDisplay = document.getElementById('destination_display');
            var purposeDisplay = document.getElementById('purpose_display');
            
            if (driverDisplay) driverDisplay.value = sel.getAttribute('data-driver') || '---';
            if (vehicleDisplay) vehicleDisplay.value = sel.getAttribute('data-vehicle') || '---';
            if (plateDisplay) plateDisplay.value = sel.getAttribute('data-plate') || '---';
            if (passengerDisplay) passengerDisplay.value = sel.getAttribute('data-passengers') || '---';
            if (destinationDisplay) destinationDisplay.value = sel.getAttribute('data-destination') || '---';
            if (purposeDisplay) purposeDisplay.value = sel.getAttribute('data-purpose') || '---';
            
            // Auto-fill issued from stock (no_of_liters from gas request)
            var issuedFromStockDisplay = document.getElementById('issued_from_stock_display');
            if (issuedFromStockDisplay) issuedFromStockDisplay.value = sel.getAttribute('data-no_of_liters') || '---';
            
            // Recompute gas total after selecting gas request
            computeGasTotal();
            
            // Fetch and auto-fill last driver trip ticket data if vehicle exists
            if (vehicleId) {
                fetchLastDriverTripTicket(vehicleId);
            }
            
            // hide modal and cleanup any leftover backdrop/modal-open state
            if (window.jQuery) {
                $('#gasRequestModal').modal('hide');
                setTimeout(function() {
                    cleanupModalState();
                }, 100);
            } else {
                cleanupModalState();
            }
            // focus back to display field so UI is interactive
            try {
                if (disp) disp.focus();
            } catch (err) {}
            return;
        }

        // pagination links
        var a = null;
        try {
            a = e.target.closest('.pagination a');
        } catch (err) {
            a = null;
        }
        if (a) {
            e.preventDefault();
            const url = a.href;
            if (!url) return;
            fetch(url, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                })
                .then(r => r.text())
                .then(html => {
                    container.innerHTML = html;
                    if (window.jQuery) {
                        $('#gasRequestModal').modal('show');
                    } else {
                        var modalEl = document.getElementById('gasRequestModal');
                        if (modalEl) {
                            modalEl.style.display = 'block';
                            modalEl.classList.add('show');
                        }
                    }
                });
        }
    });

    // intercept form submit inside modal (search)
    document.addEventListener('submit', function(e) {
        if (!container || !container.contains(e.target)) return;
        var form = e.target;
        // only handle our modal search form
        if (form.matches && !form.matches('#gasRequestSearchForm')) return;
        e.preventDefault();
        var action = form.getAttribute('action') || modalUrl;
        var params = new URLSearchParams(new FormData(form)).toString();
        var url = action + (params ? ('?' + params) : '');
        fetch(url, {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            })
            .then(r => r.text())
            .then(html => {
                container.innerHTML = html;
                if (window.jQuery) {
                    $('#gasRequestModal').modal('show');
                } else {
                    var modalEl = document.getElementById('gasRequestModal');
                    if (modalEl) {
                        modalEl.style.display = 'block';
                        modalEl.classList.add('show');
                    }
                }
            });
    });
});
